import { formAtom } from "@impero-com/common/utils/form/formAtom";
import { FormAtom } from "@impero-com/common/utils/form/formAtom/types";
import { atom, Atom, Getter, PrimitiveAtom, WritableAtom } from "jotai";
import Yup from "yup";

import { onSetAtom } from "utils/form/onSetAtom";
import { SplitAtomActionExt, splitAtomExt } from "utils/form/splitAtom";

export type InnerBaseAtomsAtom<Item> = WritableAtom<
    PrimitiveAtom<Item>[],
    [action: SplitAtomActionExt<Item>],
    void
>;

export function splitFormAtomWithoutKey<Item>(
    arrayAtom: FormAtom<Array<Item>>,
    getItemSchema: (
        itemAtom: PrimitiveAtom<Item>,
        baseAtomsAtom: InnerBaseAtomsAtom<Item>,
        baseAtomsToFormAtoms: WeakMap<Atom<Item>, FormAtom<Item>>,
        get: Getter
    ) => Yup.ISchema<Item>,
    setRevalidate: (value: Item) => void
): {
    formAtomsAtom: Atom<Array<FormAtom<Item>>>;
    baseAtomsAtom: InnerBaseAtomsAtom<Item>;
} {
    const baseAtomsAtom = splitAtomExt(arrayAtom);
    const innerBaseAtomsAtom: InnerBaseAtomsAtom<Item> = atom(
        (get) => get(baseAtomsAtom),
        (get, set, action) => {
            set(baseAtomsAtom, action);
        }
    );
    const baseAtomsToFormAtoms: WeakMap<
        Atom<Item>,
        FormAtom<Item>
    > = new WeakMap();
    const formAtomsAtom = atom((get) =>
        get(baseAtomsAtom).map((baseAtom) => {
            if (baseAtomsToFormAtoms.has(baseAtom)) {
                return baseAtomsToFormAtoms.get(baseAtom)!;
            } else {
                const fa = formAtom(
                    onSetAtom(baseAtom, (val) => {
                        setRevalidate(val);
                    }),
                    getItemSchema(
                        baseAtom,
                        innerBaseAtomsAtom,
                        baseAtomsToFormAtoms,
                        get
                    ),
                    arrayAtom
                );
                baseAtomsToFormAtoms.set(baseAtom, fa);
                return fa;
            }
        })
    );
    return {
        formAtomsAtom,
        baseAtomsAtom: innerBaseAtomsAtom,
    };
}
